"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var setAppPaneUnderlayVisibility_1 = require("owa-application/lib/actions/setAppPaneUnderlayVisibility");
var legacy_1 = require("satcheljs/lib/legacy");
exports.flexPaneUnderlayKey = 'flexPane';
exports.default = legacy_1.select({
    store: function () { return store_1.default; },
})(legacy_1.action('setFlexPaneVisibility')(function setFlexPaneVisibility(isShown, shrinkable, state) {
    state.store.isShown = isShown;
    setAppPaneUnderlayVisibility_1.default(exports.flexPaneUnderlayKey, isShown, shrinkable);
}));
//# sourceMappingURL=setFlexPaneVisibility.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-flex-pane/lib/actions/setFlexPaneVisibility.js
// module id = 4523
// module chunks = 98